import { IPerfil } from '../interfaces';

export class Perfil implements IPerfil {
  id = 0;
  nome: string = '';
  codigo: string | null = '';
  descricao: string = '';
  perfilInterno = false;
  gerarTokenEquipamento = true;
  listarDemonstrativosFinanceiros = false;
  exibirDetalhesDemonstrativoFinanceiro = false;
  realizarDownloadFechamento = false;
  listarBoletos = false;
  realizarDownloadBoleto = false;
  listarEquipamentos = false;
  realizarDownloadListagemEquipamentos = false;
  editarEquipamento = false;
  abrirChamadoEquipamento = false;
  visualizarChamadosEquipamento = false;
  listarChamadosAndamento = false;
  listarChamadosFinalizados = false;
  exibirDetalhesChamado = false;
  abrirChamadoSuprimentos = false;
  listarHistoricosPedidos = false;
  exibirDetalhesPedido = false;
  listarInventarios = false;
  exibirDetalhesInventario = false;
  alterarPosseInventario = false;
  realizarDownloadListagemInventario = false;
  listarContratos = false;
  exibirDetalhesContrato = false;
  realizarDownloadListagemContrato = false;
  realizarDownloadEquipamentosContrato = false;
  listarUsuarios = false;
  listarPerfis = false;
  controlarUsuarios = false;
  controlarPerfis = false;
  gerenciarPermissoes = false;
  gerenciarQrCode = false;
  visualizarDashboard = false;
}
